import React, { ReactNode } from 'react';
import { Link } from 'react-router';

interface Props {
  title: ReactNode;
  link: string;
  ariaLabel?: string;
  onClickOpenInNewTab?: boolean;
}

const InternalLink = ({ title, link, ariaLabel, onClickOpenInNewTab = true }: Props) => {
  return (
    <Link
      to={link}
      target={onClickOpenInNewTab ? '_blank' : ''}
      rel='noreferrer'
      className={'salv-internal-link'}
      aria-label={typeof title === 'string' ? title : ariaLabel}
    >
      {title}
    </Link>
  );
};

export default InternalLink;
